import { useState, useCallback } from "react"
import toastError from "../../errors/toastError"
import contatosTodosBuscar from "../../services/contatos/contatosTodosBuscar"
import contatosExportarXlsx from "../../utils/contatosExportarXlsx"

const useContatosExportacao = () => {
  const [aContatosExport, setAContatosExport] = useState(null)
  const [lExportPronto, setLExportPronto] = useState(false)
  const [lExportando, setLExportando] = useState(false)

  const exportarContatos = useCallback(
    async (fnAoConcluir) => {
      if (lExportPronto && aContatosExport) {
        contatosExportarXlsx(aContatosExport)
        fnAoConcluir?.()
        return
      }

      try {
        setLExportando(true)
        const { contatos } = await contatosTodosBuscar("")
        setAContatosExport(contatos)
        setLExportPronto(true)
        contatosExportarXlsx(contatos)
        fnAoConcluir?.()
      } catch (oErro) {
        toastError(oErro)
      } finally {
        setLExportando(false)
      }
    },
    [aContatosExport, lExportPronto]
  )

  return { lExportando, exportarContatos }
}

export default useContatosExportacao
